<template>
  <div>
    <transition name="fade">
      <div v-if="widguservis">
        <WidgUser />
      </div>
    </transition>

    <div v-if="widgcalcvis">
      <b-container fluid class="py-4">
        <b-row class="justify-content-center">
          <!-- Calculator -->
          <b-col cols="12" md="8" lg="6">
            <b-row class="justify-content-center">
              <b-col class="paybox mt-2" align-self="center">
                <!-- Estimate input -->
                <b-row class="estimatebox align-items-center no-gutters">
                  <b-col cols="12" md="5" class="mt-2 mt-md-0 textestimate">
                    <label for="input-small" class="text-white adjustFont m-0">Enter Estimate:</label>
                  </b-col>
                  <b-col cols="12" md="7" class="mt-2 mt-md-0">
                    <b-input-group key="sm" size="sm" prepend="$">
                      <b-form-input
                        ref="Estimate"
                        v-model="calcinput"
                        type="number"
                        name="Estimate"
                        class="paymentBox"
                      />
                    </b-input-group>
                  </b-col>
                </b-row>

                <!-- Term selector -->
                <b-row class="radioMonth">
                  <b-col class="text-center">
                    <b-form-group v-slot="{ ariaDescribedby }" class="m-0">
<b-form-radio-group
  id="btn-radios-1"
  v-model="selected"
  :options="options"
  name="radios-btn-default"
  buttons
  @input="selectedPlan"
  class="term-buttons"
/>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Payment -->
                <b-container class="paymentplan">
                  <b-row class="text-center">
                    <b-col>
                      <p class="offer">${{ updatedPayment }}</p>
                    </b-col>
                  </b-row>
                </b-container>

                <!-- Select + CTA -->
                <b-container class="pt-2 mb-3">
                  <b-row class="justify-content-center gx-2">
                    <b-col cols="12" sm="6" class="text-center mb-2 mb-sm-0">
                      <b-form-select
                        v-model="poSelected"
                        :options="payOptions"
                        size="sm"
                        class="text-center"
                        @input="selectedPlan"
                      />
                    </b-col>
                    <b-col cols="12" sm="6" class="text-center">
                      <b-button id="startedbtn" size="sm" @click="submit">Next</b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <transition name="fade">
      <div v-if="visible" class="vue-back-to-top">
        <Main />
      </div>
    </transition>
  </div>
</template>

<script>
import Loading from './loading'

let timeout = null

export default {
  name: 'NewCalc',
  components: {
    Loading,
  },
  data() {
    return {
      step: 3,
      title: 'Your payment would be',
      seen: false,
      visible: false,
      cashStatus: false,
      widgcalcvis: true,
      widguservis: false,
      poSelected: 'semimonthly',
      selected: 'radio3',
      options: [
        {
          text: '6 Months',
          value: 'radio1',
        },
        {
          text: '12 Months',
          value: 'radio2',
        },
        {
          text: '24 Months',
          value: 'radio3',
        },
        {
          text: '36 Months',
          value: 'radio4',
        },
      ],
      payOptions: [
        {
          text: 'Monthly',
          value: 'monthly',
        },
        {
          text: 'Semi Monthly',
          value: 'semimonthly',
        },
        {
          text: 'Bi-Weekly',
          value: 'biweekly',
        },
        {
          text: 'Weekly',
          value: 'weekly',
        },
      ],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      frequencyOfPayments: ['Weekly', 'Bi-weekly', 'Semi-monthly', 'Monthly'],
      amount: '1650',
      paymentType: '3',
      paymentTypeButton: false,
      repairOfferAmount: '1650',
      updatedPayment: '45',
      fees: '87',
      rate: '14.9',
      term: '24',
      vendorOfUser: '',
      calcinput: 1650,
      currentYear: '',
      loanRatio: '',
      approvedLoan: '',
      maxLoanAmount: '',
      finalLoanAmount: '',
      repairAmount: '',
      boundaryLimit: '',
      minimumLoan: '',
      isHidden: true,
      selectedRepair: 'Choose...',
      repairOptions: [
        'Mechanical',
        'Collision',
        'Electrical',
        'Rust',
        'Exhaust',
        'Rims And Tires',
        'Choose...',
      ],
    }
  },

  watch: {
    calcinput() {
      const localThis = this
      if (this.calcinput < 10001 && this.calcinput > 499) {
        localThis.repairOfferAmount = localThis.calcinput
        console.log('this is repairofferamount' + localThis.repairOfferAmount)
        if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          // 12 months and Semi monthly [3,12]
          localThis.calculatePayment.call(this, [3, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [2, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [3, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [3, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [2, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [2, 36])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [2, 6])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [3, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [2, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [3, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [0, 12])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio2') {
          localThis.calculatePayment.call(this, [1, 12])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [0, 24])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [0, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio3') {
          localThis.calculatePayment.call(this, [1, 24])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio4') {
          localThis.calculatePayment.call(this, [1, 36])
        } else if (localThis.poSelected === 'monthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [1, 6])
        } else if (localThis.poSelected === 'semimonthly' && localThis.selected === 'radio1') {
          localThis.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [1, 12])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio2') {
          this.calculatePayment.call(this, [0, 12])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [1, 24])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [1, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio4') {
          this.calculatePayment.call(this, [0, 36])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio3') {
          this.calculatePayment.call(this, [0, 24])
        } else if (this.poSelected === 'weekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [0, 6])
        } else if (this.poSelected === 'biweekly' && this.selected === 'radio1') {
          this.calculatePayment.call(this, [1, 6])
        }
      } else if (this.calcinput > 10000) {
        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        this.updatedPayment = '500 Min.'
      }
    },
    // The new function
    paymentTypeButton() {
      this.selectedPlan()
    },
  },
  mounted() {
    // this.focusInput();
    console.log(this)
    this.repairOfferAmount = this.$store.state.userData.repairOfferAmount
    this.calcinput = this.$store.state.userData.repairOfferAmount
    console.log(this.repairOfferAmount)
  },
  created() {
    this.currentYear = new Date().getFullYear()
    this.loanRatio = 1 - (this.currentYear - this.$store.state.userData.year) / 35
    this.approvedLoan = Math.trunc(
      this.$store.state.userData.marketValue * 0.3 * 0.7 * this.loanRatio
    )
    this.repairAmount = this.$store.state.userData.repairOfferAmount
    // Check the maximum amount possible to take if the approved loan is lower than the repair offer
    this.maxLoanAmount =
      this.approvedLoan > this.repairAmount ? this.repairAmount : this.approvedLoan

    this.boundaryLimit = this.maxLoanAmount > 10000 ? 10000 : this.maxLoanAmount
    // Check if the customer needs to bring cash because his approved amount doesn't cover the repair offer
    this.minimumLoan =
      this.approvedLoan > this.repairAmount ? 500 : this.repairAmount - this.approvedLoan
    // set default highest loan possible
    this.finalLoanAmount = this.boundaryLimit
    // store the data
    this.$store.state.userData.boundaryAmount =
      this.approvedLoan > 10000 ? 10000 : this.approvedLoan
    this.$store.state.userData.payment = this.calcPayment
    this.$store.state.userData.paymentTotal = this.finalLoanAmount
    // is the below line important?
    this.$store.state.userData.paymentPeriod = `${this.term} months`
    this.$store.state.userData.term = this.term
  },
  methods: {
    closereseize() {
      if ('parentIFrame' in window) window.parentIFrame.size(70)
      return false
    },
    onpicOne() {
      if ('parentIFrame' in window) window.parentIFrame.size(409)
      return false
    },
    closeWin() {
      return [(this.widgcalcvis = false), (this.visible = true)]
    },
    next() {
      this.$store.state.userData.paymentMethod = this.paymentMethod
      this.widguservis = !this.widguservis
      this.widgcalcvis = false
    },
    // Two function for the spinner
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    process() {
      if (timeout) clearTimeout(timeout)
      this.counter++
      this.seen = true
      this.textSeen = false
      timeout = setTimeout(this.fetchHole, 700)
    },
    fetchHole() {
      this.textSeen = true
      this.seen = false
    },
    focusInput() {
      this.$refs.Estimate.focus()
    },
    next() {
      this.$store.state.userData.selectedRepair = this.selectedRepair
    },
    submit() {
      this.$store.state.userData.payment = this.updatedPayment
      this.$store.state.userData.loanRequested = this.repairOfferAmount
      this.$store.state.userData.repairOfferAmount = this.repairOfferAmount
      this.$store.state.userData.paymentPeriod = this.term
      this.$store.state.step = 4
      this.widguservis = !this.widguservis
      this.widgcalcvis = false
    },
    test() {
      console.log('working')
    },
    calculatePayment(pType) {
      this.term = pType[1]
      if (pType[1] === 6) {
        var myThis = this
        this.$store.state.userData.paymentPeriod = pType[1]
        console.log('is this logged ' + this.$store.state.userData.paymentPeriod)
        const paymentPeriod = [4.33333333, 2.1666666, 2, 1]
        console.log('calculateP repair offer amount' + myThis.repairOfferAmount)
        const amount = myThis.repairOfferAmount
        const interest = 0.001
        const fees = this.fees
        let allPayments = 0
        const numpayments = pType[1] * paymentPeriod[pType[0]]
        const rate = parseFloat(interest) / (paymentPeriod[pType[0]] * 6) / 100
        if (amount < 2500) {
          allPayments = parseFloat(amount) + parseFloat(fees) + amount * 0.009
        } else {
          allPayments = parseFloat(amount) + parseFloat(fees) + amount * 0.018
        }
        const totalmonthlypayment =
          (allPayments * rate * Math.pow(1 + rate, numpayments)) /
          (Math.pow(1 + rate, numpayments) - 1)

        this.$store.state.userData.numberOfPayments = numpayments
        console.log('is this' + this.$store.state.userData.numberOfPayments)
        this.$store.state.userData.paymentFees = allPayments - amount
        console.log('fees' + this.$store.state.userData.paymentFees)
        myThis.updatedPayment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.payment = totalmonthlypayment
        this.$store.state.userData.repairOfferAmount = myThis.repairOfferAmount
        this.$store.state.userData.loanRequested = myThis.repairOfferAmount
        console.log('before issue')
        // Set the payment period in the store
        if (paymentPeriod[pType[0]] === 1) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0]
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1]
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2]
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3]
        }
      } else {
        var myThis = this
        const paymentPeriod = [4.33333333, 2.1666666, 2, 1]
        const amount = myThis.repairOfferAmount
        const interest = myThis.rate
        const fees = myThis.fees
        const numpayments = pType[1] * paymentPeriod[pType[0]]
        console.log('nmpayment' + numpayments)
        const rate = parseFloat(interest) / (paymentPeriod[pType[0]] * 12) / 100
        const aprRate = parseFloat(27.9) / (paymentPeriod[pType[0]] * 12) / 100
        console.log('apr rate' + aprRate)
        console.log('amount' + amount)
        const allPayments = parseFloat(amount) + parseFloat(fees)
        let totalmonthlypayment =
          (parseFloat(amount) * aprRate * Math.pow(1 + aprRate, numpayments)) /
          (Math.pow(1 + aprRate, numpayments) - 1)
        const noFeesMonthlyPayment =
          (allPayments * rate * Math.pow(1 + rate, numpayments)) /
          (Math.pow(1 + rate, numpayments) - 1)
        if (noFeesMonthlyPayment > totalmonthlypayment) {
          totalmonthlypayment = noFeesMonthlyPayment
        }
        const paymentFees = totalmonthlypayment - noFeesMonthlyPayment
        console.log('total monthly payment' + totalmonthlypayment)
        console.log('noFeesMonthlyPayment' + noFeesMonthlyPayment)
        console.log(paymentFees)
        this.updatedPayment = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.paymentPeriods = numpayments
        this.$store.state.userData.numberOfPayments = pType[1]
        this.$store.state.userData.paymentFees = paymentFees.toFixed(2)
        console.log('fees to charge ' + this.$store.state.userData.paymentFees)
        this.$store.state.userData.loanApr = totalmonthlypayment.toFixed(2)
        this.$store.state.userData.payment = totalmonthlypayment.toFixed(2)
        console.log('New Regular payment: ' + totalmonthlypayment.toFixed(2))
        this.$store.state.userData.invoiceBeforeTax = (myThis.repairOfferAmount / 1.12).toFixed(2)
        console.log('invoice before tax: ' + this.$store.state.userData.invoiceBeforeTax)
        this.$store.state.userData.PrincipalAmount = myThis.repairOfferAmount * 1 + myThis.fees * 1
        console.log('Principal Amount: ' + this.$store.state.userData.PrincipalAmount)
        this.$store.state.userData.newAPR = (1 * totalmonthlypayment).toFixed(4)
        console.log('New APR ' + this.$store.state.userData.newAPR)
        this.$store.state.userData.vendorToPay = (
          ((1 * myThis.repairOfferAmount) / 1.12) *
          1.05
        ).toFixed(2)
        console.log('Vendor topay: ' + this.$store.state.userData.vendorToPay)
        if (paymentPeriod[pType[0]] === 1 || paymentPeriod[pType[0]] === 2) {
          var paydate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 3)
          this.$store.state.userData.firstPaymentDay = paydate
        } else {
          var myThis = this
          var today = new Date()
          today.setDate(today.getDate() + ((12 - today.getDay()) % 7))
          this.$store.state.userData.firstPaymentDay = today
        }
        var myThis = this
        console.log('first payment date ' + this.$store.state.userData.firstPaymentDay)
        console.log('Number of Payments' + numpayments)
        this.$store.state.userData.totalPayments = this.$store.state.userData.payment * numpayments
        console.log('Total Payments: ' + this.$store.state.userData.totalPayments)
        this.$store.state.userData.loanRequested = myThis.repairOfferAmount
        console.log('Repair Amount: ' + this.$store.state.userData.loanRequested)
        this.$store.state.userData.costOfFinancing = (
          1 * this.$store.state.userData.totalPayments -
          1 * myThis.repairOfferAmount
        ).toFixed(2)
        console.log('Repair Cost of Financing: ' + this.$store.state.userData.costOfFinancing)
        this.$store.state.userData.frequencyText = myThis.frequencyOfPayments[pType[0]]
        console.log('The frequency is: ' + this.$store.state.userData.frequencyText)
        if (paymentPeriod[pType[0]] === 1) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[0]
        } else if (paymentPeriod[pType[0]] === 2) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[1]
        } else if (paymentPeriod[pType[0]] === 2.1666666) {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[2]
        } else {
          this.$store.state.userData.paymentFrequency = this.frequencyOfPayments[3]
        }
      }
    }, // close calculate payment function
    selectedPlan() {
      const localThis = this
      // const paymentPeriod = [4.34524, 2.17262, 2, 1]
      console.log('calcinput' + this.calcinput)
      console.log('radio' + this.selected)
      if (this.calcinput < 10001 && this.calcinput > 499) {
        console.log('true')
        this.repairOfferAmount = this.calcinput
        let paymentParams
        if (this.poSelected === 'monthly') {
          if (this.selected === 'radio1') {
            paymentParams = [3, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [3, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [3, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [3, 36]
          }
        } else if (this.poSelected === 'semimonthly') {
          if (this.selected === 'radio1') {
            paymentParams = [2, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [2, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [2, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [2, 36]
          }
        } else if (this.poSelected === 'biweekly') {
          if (this.selected === 'radio1') {
            paymentParams = [1, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [1, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [1, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [1, 36]
          }
        } else if (this.poSelected === 'weekly') {
          if (this.selected === 'radio1') {
            paymentParams = [0, 6]
          } else if (this.selected === 'radio2') {
            paymentParams = [0, 12]
          } else if (this.selected === 'radio3') {
            paymentParams = [0, 24]
          } else if (this.selected === 'radio4') {
            paymentParams = [0, 36]
          }
        }

        if (paymentParams) {
          this.calculatePayment.call(this, paymentParams)
        }
      } else if (this.calcinput > 10000) {
        console.log('true')

        this.updatedPayment = '10K Max.'
      } else if (this.calcinput < 500) {
        console.log('true')

        this.updatedPayment = '500 Min.'
      }
    },
  },
}
</script>

<style scoped>
/* --- Buttons & radios ---------------------------------------------------- */
.btn { background-color: #f15b22 !important; }
.b-form-radio-group { background-color: transparent !important; }

/* Make the radio button set wrap on small screens */
.term-buttons .btn-group {
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
  width: 100%;
  white-space: normal;      /* override Bootstrap's nowrap */
}
.term-buttons .btn-group .btn {
  flex: 1 1 calc(50% - .5rem);
  min-width: 0;            /* prevents overflow */
}

/* Allow horizontal scroll if space is extremely tight */
.term-scroll { overflow: visible; }

/* --- Typography ---------------------------------------------------------- */
h4 { font-size: clamp(1rem, 3vw, 2em); color: grey; text-transform: uppercase; }
.paymentBox, .paymentBoxTwo { font-size: 1rem; font-weight: bold; }
.offer { color: #fff !important; font-size: clamp(2rem, 10vw, 3.5rem); line-height: 1.1; margin: 0; }
.titlefont { color: #f15b22 !important; font-size: clamp(1.25rem, 4vw, 2rem); }
.subtitlefont { color: #009579 !important; font-size: clamp(1rem, 3.5vw, 2rem) !important; }
.text-label { line-height: 1.5; font-size: 1rem; font-family: Poppins; }

/* --- Containers & boxes -------------------------------------------------- */
.container, .container-fluid { max-width: 1600px; }
.paybox { background-color: #1870c8; border-radius: 20px; padding: 1rem; }
.estimatebox {
  background-color: #326ba4;
  border-radius: 12px;
  min-height: 56px;               /* Remove hard fixed heights */
  padding: .5rem .75rem;
}
.paymentplan { padding: .75rem 0; }

#startedbtn { background-color: #f6c215 !important; color: #000; }

/* Input styling */
.input-group .form-control:not(:last-child) { border-right: 0; padding-right: 0; }
.form-control:disabled, .form-control[readonly] { background-color: #cff7d7 !important; opacity: 1; }

/* --- Layout helpers ------------------------------------------------------ */
.radioMonth { margin-top: 12px; }
.textestimate { text-align: left; }

/* Kill rigid heights that break mobile */
#home, .background, .container-fluidback, .container-fluid {
  height: auto !important;
}

/* Optional background animation remains intact but won't force height */
.background {
  background: linear-gradient(132deg, #e6efed, #dbfcf6, #ffffff);
  background-size: 400% 400%;
  animation: Gradient 15s ease infinite;
  width: 100%;
  overflow: hidden;
  margin: 0;
}

/* Keep fun cubes but ensure they don't block layout */
.cube { position: absolute; width: 10px; height: 10px; border: 1px solid #d7d4e4; transform-origin: top left; }
.cube:nth-child(2n) { border-color: #fff; }

@keyframes Gradient {
  0% { background-position: 0 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

/* --- Responsive tweaks --------------------------------------------------- */
@media (min-width: 576px) {
  .term-buttons .btn-group .btn { flex: 1 1 calc(25% - .5rem); }
}
@media (min-width: 992px) {
  .term-buttons .btn-group .btn { flex: 0 0 auto; } /* no forced width on large screens */
}
</style>



// WEBPACK FOOTER //
// src/components/new_calc.vue